import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter007() {
  return <KbChapterPage slug="chapter-007" />;
}

(Chapter007 as unknown as { path: string }).path = "/theory-album/007";
